import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const FAQPage = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How far in advance should I book?',
    answer: 'We recommend booking at least 2-3 weeks in advance to ensure availability, especially for weekend dates. For special occasions like holidays or peak seasons, booking 4-6 weeks ahead is ideal.'
  }, {
    question: 'Do you charge for delivery?',
    answer: 'Delivery is complimentary for locations within 30 minutes of our base in Douglasville.\n\nFor locations beyond that:\n\n– 31–45 minutes: $25\n\n– 46–60 minutes: $50\n\n– Over 60 minutes: Contact us to check availability and get a custom quote.'
  }, {
    question: 'How long does setup and takedown take?',
    answer: 'Our team typically arrives about an hour before your event to complete setup. Takedown usually takes about 45 minutes. We handle everything so you can focus on enjoying the party!'
  }, {
    question: 'Is your equipment sanitized between uses?',
    answer: "Absolutely! We thoroughly clean and sanitize all equipment between each rental using child-safe disinfectants. Your child's safety and health is our top priority."
  }, {
    question: 'What space requirements do I need?',
    answer: 'Space requirements vary by package. For example, our Tiny Tot package needs about 12ft x 10ft, while our larger Gigantatot requires 18ft x 16ft. We can always work with you to customize a setup for your specific space - just ask!'
  }, {
    question: 'What ages are your soft play rentals suitable for?',
    answer: 'Our soft play setups and bounce houses are designed for children ages 1–5, ensuring fun and safety for little ones.'
  }, {
    question: 'What is your cancellation policy?',
    answer: 'Cancellation Policy\n\nTo reserve your event date, we only require a deposit at the time of booking. The deposit is non-refundable unless the reservation is canceled within 48 hours of booking. If you cancel after the 48-hour period, you will forfeit the deposit, but you will not be responsible for paying the remaining balance. The remaining balance is due upon delivery and setup of your rental.\n\nRescheduling Policy\n\nYou may reschedule once at no additional cost (subject to availability), as long as the new date is within 12 months.\n\nWeather Policy\n\nIn the event that the forecasted probability of rain or inclement weather during the scheduled outdoor event is determined to be high enough to pose a risk to our equipment or operations, Toddler Time reserves the right to cancel/reschedule services in order to protect equipment and ensure safety. In such cases, we will remain in communication with the client and work collaboratively to identify suitable alternatives (i.e. indoor set up) or reschedule the event, striving to provide the best possible solution under the circumstances.'
  }];
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-primary-50 min-h-screen py-16" data-id="element-768">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-769">
        <div className="text-center mb-12" data-id="element-770">
          <h1 className="text-4xl font-bold text-gray-900" data-id="element-771">
            Frequently Asked Questions
          </h1>
          <p className="mt-4 text-lg text-gray-500" data-id="element-772">
            Everything you need to know about our soft play rentals
          </p>
        </div>
        <div className="space-y-6" data-id="element-773">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-774">
              <button className="w-full px-6 py-4 flex justify-between items-center text-left bg-white hover:bg-gray-50 transition" onClick={() => toggleFaq(index)} data-id="element-775">
                <span className="text-lg font-medium text-gray-900" data-id="element-776">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`h-5 w-5 text-gray-500 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-777" />
              </button>
              {openIndex === index && <div className="px-6 pb-4 bg-gray-50" data-id="element-778">
                  <p className="text-base text-gray-600 whitespace-pre-line" data-id="element-779">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
        <div className="mt-12 text-center" data-id="element-780">
          <p className="text-gray-600" data-id="element-781">
            Have more questions?{' '}
            <Link to="/contact" className="font-medium text-blue-500 hover:text-blue-600" onClick={() => window.scrollTo(0, 0)} data-id="element-782">
              Contact us
            </Link>{' '}
            and we'll be happy to help!
          </p>
        </div>
      </div>
    </div>;
};